import moment from "moment";
import { useState } from "react";
import { EndPoints } from "../../../../Constants/endpoints";
import { IMonthAppointments } from "../../../../interface/appointmentInterfaces";
import { useGetData } from "../../../../hooks";
import { GeneralCalendar } from "../../../../components";

interface AppointmentsCalendarProps {
  isFull?: boolean;
}

const AppointmentsCalendar: React.FC<AppointmentsCalendarProps> = ({
  isFull = false,
}) => {
  const [currentDate, setCurrentDate] = useState({
    Month: moment().locale("en").format("MM"),
    Year: moment().locale("en").format("YYYY"),
  });

  const queryParams = { Month: currentDate.Month, Year: currentDate.Year };

  const { data } = useGetData<IMonthAppointments[]>(
    EndPoints.GetMonthAppointments,
    {
      filter: queryParams,
      staleTime: 5 * 60 * 1000,
    },
  );

  const appointmentsMonthData: IMonthAppointments[] = data?.Data ?? [];

  return (
    <div className="relative">
      <GeneralCalendar
        withDeselect
        calendarKey="appointment"
        isFull={isFull}
        className={
          isFull ? "mt-2 !w-full" : "!w-[92vw] lg:!w-[18rem] xl:!w-[22rem]"
        }
        onNavigate={(date) => {
          setCurrentDate({
            Month: moment(date).locale("en").format("MM"),
            Year: moment(date).locale("en").format("YYYY"),
          });
        }}
        extraCellContent={(date: Date) => {
          const dayAppointments = appointmentsMonthData.find((item) =>
            moment(date).isSame(moment(item?.Date), "day"),
          );
          const appointmentsCount =
            Number(dayAppointments?.Approved) +
            Number(dayAppointments?.Pending);

          return (
            <div
              className={`appointment-point absolute bottom-1 flex gap-0.5 text-2xl font-bold leading-8`}
            >
              {appointmentsCount > 0 && (
                <>
                  {new Array(Math.min(appointmentsCount, 3))
                    .fill(0)
                    .map((_, index: number) => (
                      <span key={index}>.</span>
                    ))}
                </>
              )}
            </div>
          );
        }}
      />
    </div>
  );
};

export default AppointmentsCalendar;
